import Image from 'components/Image'
import styles from './AccountItem.module.scss'

/**
 * AccountItem is much like un-editable cart item.
 * Due to design changeds in cart-item, it has come to live
 * it's own life with slightly different design.
 */
export default function AccountItem({ item }) {
  const { event, date, people, message } = item
  const { price, image, name } = event

  return (
    <div className={styles.teaser}>
      <div className={styles.wrap}>
        <div className={styles.imageWrap}>
          <div className={styles.imageFrame}>
            {image && (
              <Image image={image} size="teaser-retina" layout="responsive" />
            )}
          </div>
        </div>
        <div className={styles.contentWrap}>
          <p className={styles.details}>
            <span className={styles.detail}>{date}</span>
            <span className={styles.detail}>{people} hlöä</span>
          </p>
          <h5 className={styles.title}>{name}</h5>
          <p className={styles.price}>{price}</p>
        </div>
        <div className={styles.messageWrap}>
          <textarea
            className={styles.message}
            value={message}
            disabled={true}
          />
        </div>
      </div>
    </div>
  )
}
